import React from 'react';

const ExerciseLayout = ({
  title,
  subtitle,
  color = 'blue',
  icon,
  progress,
  onBack,
  twoColumn = false,
  children
}) => {
  const colorClasses = {
    purple: {
      iconBg: 'bg-purple-100',
      iconText: 'text-purple-600',
      progressStroke: '#a855f7'
    },
    amber: {
      iconBg: 'bg-amber-100',
      iconText: 'text-amber-600',
      progressStroke: '#f59e0b'
    },
    blue: {
      iconBg: 'bg-blue-100',
      iconText: 'text-blue-600',
      progressStroke: '#3b82f6'
    },
    rose: {
      iconBg: 'bg-rose-100',
      iconText: 'text-rose-600',
      progressStroke: '#f43f5e'
    }
  };

  const colors = colorClasses[color] || colorClasses.blue;
  const maxWidth = twoColumn ? 'max-w-[1400px]' : 'max-w-4xl';

  const progressPercent = progress ? (progress.current / progress.total) * 100 : 0;
  const circumference = 2 * Math.PI * 35;
  const strokeDasharray = `${(progressPercent / 100) * circumference} ${circumference}`;

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-100 to-gray-200 p-4 md:p-6">
      <div className={`${maxWidth} mx-auto`}>
        {/* Back button */}
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-800 mb-4 transition-colors"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span>Zpět na menu</span>
        </button>

        {/* Header Card */}
        <div className="bg-white rounded-2xl shadow-lg px-5 py-3 mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              {icon && (
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center text-xl ${colors.iconBg}`}>
                  {icon}
                </div>
              )}
              <div>
                <h1 className="text-lg font-bold text-gray-800">{title}</h1>
                {subtitle && (
                  <p className="text-sm text-gray-500">{subtitle}</p>
                )}
              </div>
            </div>

            {/* Progress indicator */}
            {progress && (
              <div className="flex items-center">
                <div className="relative w-12 h-12">
                  <svg className="w-12 h-12 transform -rotate-90">
                    <circle
                      cx="24"
                      cy="24"
                      r="20"
                      stroke="#e5e7eb"
                      strokeWidth="4"
                      fill="none"
                    />
                    <circle
                      cx="24"
                      cy="24"
                      r="20"
                      stroke={colors.progressStroke}
                      strokeWidth="4"
                      fill="none"
                      strokeDasharray={`${(progress.current / progress.total) * 126} 126`}
                      strokeLinecap="round"
                    />
                  </svg>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="text-sm font-bold text-gray-800">
                      {progress.current}/{progress.total}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Content */}
        {children}
      </div>
    </div>
  );
};

export default ExerciseLayout;
